import React from "react";
import { PropTypes } from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { tGenerics } from "../../utils/table";

const [HbrIcon, HbrPortal, HbrTooltip] =
  reactWrapper(["hbr-icon", "hbr-portal", "hbr-tooltip"]);

const LockIcon = ({ id }) => {
  const tooltipId = `lock-icon-tooltip_${id}`;

  return (
    <>
      <HbrIcon name="lock" sentiment="neutral" id={tooltipId} />
      <HbrPortal>
        <HbrTooltip anchor={`#${tooltipId}`}>
          <div slot="content">
            {tGenerics('auth.disabled')}
          </div>
        </HbrTooltip>
      </HbrPortal>
    </>
  );
};

LockIcon.propTypes = {
  id: PropTypes.string.isRequired
};

export default LockIcon;
